<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="flex w-full bg-img" :class="{'h-screen': size === 'large'}">
		<div
			class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
		>
			<img
				:class="{
					'img-size': size === 'large',
					'img-small': size === 'small',
				}"
				src="@/assets/images/pages/not-authorized.png"
				alt="graphic-not-authorized"
				class="mx-auto mb-4"
			/>
			<h1
				class="sm:mx-0 mx-4 sm:mb-5 mb-1 d-theme-heading-color"
				:class="{
					'text-5xl': size === 'large',
					'text-2xl': size === 'small',
				}"
			>
				{{ $t("NotPermissionPage.NotPermissions") }}
			</h1>
			<p class="sm:mx-0 mx-4 sm:mb-12 mb-8" v-if="size === 'large'">
				{{ $t("NotPermissionPage.NotPermissionsText") }}
			</p>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		size: {
			type: String,
			default: "large",
		},
	},
};
</script>
<style lang="scss" scoped>
.img-size {
	margin-top: -100px;
}
.img-small {
	width: 150px;
	height: auto;
}
</style>
